@if (loading()) {
  <spx-spinner [spxLoaderText]="txtLoading() | translate" />
}
<spx-toaster [messages]="messages()" (spxClose)="onCloseMessage($event)" />
<app-shortcuts />
<spx-confirm-displayer />

<ion-app>
  <ion-router-outlet class="font-body" />
</ion-app>
